import React from 'react';
import { useTranslation } from 'react-i18next';

import Slider from '@mui/material/Slider';

function DurationSlider({ value, onChange, tKey }: any) {
    const { t } = useTranslation(undefined, { keyPrefix: tKey });
    const minimumDays = t('minimumDays');
    const maximumDays = t('maximumDays');
    const noLimit = t('noLimit');

    const handleChange = (_: any, newValue: any) => {
        const nextMax = newValue?.[1] >= 90 ? Number.POSITIVE_INFINITY : newValue?.[1];
        onChange?.([newValue?.[0] ?? 0, nextMax]);
    };
    const maxValue = Number.isFinite(value?.[1]) ? value[1] : 90;

    return (
        <div className='flex flex-col gap-6'>
            <div className='px-1'>
                <Slider
                    value={[value?.[0] ?? 0, maxValue]}
                    onChange={handleChange}
                    valueLabelDisplay='off'
                    min={0}
                    max={90}
                    disableSwap
                    sx={{
                        color: '#3F8EE8',
                        height: 12,
                        '& .MuiSlider-track': {
                            border: 'none',
                        },
                        '& .MuiSlider-rail': {
                            opacity: 0.25,
                            backgroundColor: '#D1D5DB',
                        },
                        '& .MuiSlider-thumb': {
                            height: 32,
                            width: 32,
                            backgroundColor: '#fff',
                            border: '2px solid #DFE1E6',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            '&:hover, &.Mui-focusVisible': {
                                boxShadow: '0 4px 14px rgba(63, 142, 232, 0.35)',
                            },
                            '&:before': {
                                display: 'none',
                            },
                        },
                    }}
                />
            </div>
            <div className='flex items-center justify-between gap-4'>
                <div className='flex flex-col items-center gap-3'>
                    <span className='text-base font-semibold text-[#595A5C]'>{minimumDays}</span>
                    <div className='flex h-10 w-[104px] items-center justify-center rounded-full border border-[#DFE1E6] bg-white text-lg font-bold text-[#595A5C]'>
                        {value?.[0] ?? 0}
                    </div>
                </div>
                <div className='flex flex-col items-center gap-3'>
                    <span className='text-base font-semibold text-[#595A5C]'>{maximumDays}</span>
                    <div className='flex h-10 w-[104px] items-center justify-center rounded-full border border-[#DFE1E6] bg-white text-lg font-bold text-[#595A5C]'>
                        {Number.isFinite(value?.[1]) ? value[1] : noLimit}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DurationSlider;
